import { createFileRoute } from '@tanstack/react-router';
import { StatutoryReportSummaryProfileRegistryPage } from './-components/StatutoryReportSummaryProfileRegistryPage';
export const Route = createFileRoute('/_staff/salary-and-wages-mock/_layout/settings/statutory-report-summaries/')({
  component: StatutoryReportSummaryProfileRegistryPage
});